// @flow
import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import SimpleBar from "simplebar-react";
import { useTranslation } from "react-i18next";
import i18n from "i18next";
import RemainingTime from "./RemainingTime";
// notifiaction continer styles
const notificationContainerStyle = {
  maxHeight: "230px",
  display: "none",
};

const notificationShowContainerStyle = {
  maxHeight: "230px",
};

const NotificationDropdown = (props) => {
  const { t } = useTranslation();
  const location = useLocation();
  const currentLanguage = i18n.language.split("-")[0];
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [notificationContentStyle, setNotificationContentStyles] = useState(
    notificationContainerStyle
  );
  const [notifiactionCount, setNotificationCount] = useState(0);

  // show last notification first
  const notifications = props.notifications || [];
  notifications.sort((a, b) =>
    a.createdAt < b.createdAt ? 1 : b.createdAt < a.createdAt ? -1 : 0
  );

  useEffect(() => {
    setNotificationCount(notifications.length);
  }, [props, notifications.length]);

  /*
   * toggle notification-dropdown
   */
  const toggleDropdown = () => {
    if (!dropdownOpen) {
      /*  logEvent(analytics, "topbar_notification_dropdown"); */
    }
    setDropdownOpen(!dropdownOpen);
    setNotificationContentStyles(
      notificationContentStyle === notificationContainerStyle
        ? notificationShowContainerStyle
        : notificationContainerStyle
    );
  };
  const onClickClearAllHandler = () => {
    /*  logEvent(analytics, "topbar_notification_clear_all"); */
    const ids = [];
    notifications.map((notification) => {
      ids.push(notification.id);
    });
    props.onClearNotification(ids);
  };
  const onNotificationClickHandler = (clicked) => {
    /*   logEvent(analytics, "topbar_notification_click"); */
    const ids = [];
    ids.push(clicked.currentTarget.dataset.id);
    props.onClearNotification(ids);
  };

  return (
    <Dropdown show={dropdownOpen} onToggle={toggleDropdown}>
      <Dropdown.Toggle
        variant="link"
        id="dropdown-notification"
        as={Link}
        to={location.search ? location.search : location.pathname}
        // to="#"
        onClick={toggleDropdown}
        className="nav-link dropdown-toggle arrow-none"
      >
        <i className="dripicons-bell noti-icon"></i>
        {notifiactionCount > 0 ? (
          //   <span className="noti-icon-badge"></span>
          <span className="top-0 start-100 translate-middle badge rounded-pill bg-danger">
            {notifiactionCount}
            <span className="visually-hidden">unread messages</span>
          </span>
        ) : null}
      </Dropdown.Toggle>
      <Dropdown.Menu
        className="dropdown-menu dropdown-menu-end dropdown-menu-animated dropdown-lg"
        style={{ width: window.innerWidth >= 598 ? "400px" : "100vw" }}
      >
        <div onClick={toggleDropdown}>
          <div className="dropdown-item noti-title">
            <h5 className="m-0  ">
              <div
                onClick={onClickClearAllHandler}
                className="float-end curser-pointer"
              >
                <small role="button">{t("Read All")}</small>
              </div>
              <Link to="/notifications?messages=unread&page=1">
                {t("View all")}
              </Link>
            </h5>
          </div>
          <SimpleBar style={notificationContentStyle}>
            {notifications.map((item, i) => {
              // calculate duration
              const { selected_duration, duration_type } = RemainingTime(
                item.createdAt
              );

              return (
                <Link
                  to={item.reference.url ? item.reference.url : "#"}
                  onClick={onNotificationClickHandler}
                  className="dropdown-item notify-item"
                  key={item.id}
                  data-id={item.id}
                >
                  <div
                    className={`notify-icon align-items-center bg-${item.bgColor}`}
                    style={{ backgroundColor: item.iconBackgroundColor }}
                  >
                    <i className={item.icon}></i>
                  </div>
                  <p className="notify-details" style={{ fontSize: "0.7em" }}>
                    {/* {item.date} */}
                    {currentLanguage === "de"
                      ? `vor ${selected_duration} ${t(duration_type)}`
                      : `${selected_duration} ${t(duration_type)} ago`}
                  </p>
                  <p className="notify-details">{t(item.title)} </p>
                  <p className="text-muted mb-0 user-msg">
                    <small>
                      {item.message}
                      {/* {translated_notification_message} */}
                    </small>
                  </p>
                </Link>
              );
            })}
          </SimpleBar>
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default NotificationDropdown;
